import {Link, styled} from '@mui/material';

export const StyledLink = styled(Link)(({theme}) => ({
  cursor: 'pointer',
  color: theme.palette.common.white,
  textDecoration: 'underline'
}));
